import { authFetch } from './client';

export const listMembers = (orgId) => authFetch(`/api/orgs/${orgId}/members`);
export const updateMemberRole = (orgId, userId, role) =>
  authFetch(`/api/orgs/${orgId}/members/${userId}`, {
    method: 'PATCH',
    body: JSON.stringify({ role }),
  });
export const removeMember = (orgId, userId) =>
  authFetch(`/api/orgs/${orgId}/members/${userId}`, { method: 'DELETE' });
export const inviteMember = (orgId, email, role) =>
  authFetch(`/api/orgs/${orgId}/invites`, {
    method: 'POST',
    body: JSON.stringify({ email, role }),
  });
export const listInvites = (orgId) => authFetch(`/api/orgs/${orgId}/invites`);
export const revokeInvite = (orgId, inviteId) =>
  authFetch(`/api/orgs/${orgId}/invites/${inviteId}`, { method: 'DELETE' });
